import { GROUPS, PREFIX_PROXY } from '@/service/apiConf';
import { get } from '@/service/request';

/** 获取工作负载修改记录 Deployment */
export const getReplicasets = ({
  cluster,
  namespace,
  labelSelector,
}: {
  cluster: string;
  namespace: string;
  labelSelector?: string;
}): Promise<any> =>
  get(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/replicasets`, {
    labelSelector,
  });

/** 获取工作负载修改记录 StatefulSet, Daemonset */
export const getControllerreVisions = ({
  cluster,
  namespace,
  labelSelector,
}: {
  cluster: string;
  namespace: string;
  labelSelector?: string;
}) =>
  get(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/controllerrevisions`, {
    labelSelector,
  });
